module.exports = __webpack_public_path__ + "static/media/bannar-h5.3fe9a291.png";